var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgFlagEnGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 24 18M24 0 0 18",
    stroke: "#FFFFFF",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 24 18M24 0 0 18",
    stroke: "#C8102E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V18M0 9H24",
    stroke: "#FFFFFF",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V18M0 9H24",
    stroke: "#C8102E",
    strokeWidth: 3.6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 17,
    rx: 1.5,
    fill: "none",
    stroke: "#212121",
    strokeOpacity: 0.12
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEnGb);
export default __webpack_public_path__ + "static/media/flag-en-GB.e6d01f6bc8764e7e7cf223ffe2d40da5.svg";
export { ForwardRef as ReactComponent };